import * as Immutable from 'immutable';
import {
  CLEAR_APPROVAL_DOC,
  GET_APPROVAL_DOCS_REQUESTED,
  GET_APPROVAL_DOCS_COMPLETED,
  GET_APPROVAL_DOCS_FAILED,
  GET_APPROVAL_DOCS_ABORTED,
  GET_ASSIGNED_APPROVAL_DOCS_REQUESTED,
  GET_ASSIGNED_APPROVAL_DOCS_COMPLETED,
  GET_ASSIGNED_APPROVAL_DOCS_FAILED,
  DOWNLOAD_ASSIGNED_APPROVAL_DOCS_REQUESTED,
  DOWNLOAD_ASSIGNED_APPROVAL_DOCS_COMPLETED,
  DOWNLOAD_ASSIGNED_APPROVAL_DOCS_FAILED,
  SET_SIGNED_APPROVAL_DOC_REQUESTED,
  SET_SIGNED_APPROVAL_DOC_COMPLETED,
  SET_SIGNED_APPROVAL_DOC_FAILED,
  SET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED,
  SET_ACTIONAPPROVALDOCID_ROUTE_ABORTED,
  SET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED,
  SET_ACTIONAPPROVALDOCID_ROUTE_FAILED,
  RESET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED,
  RESET_ACTIONAPPROVALDOCID_ROUTE_ABORTED,
  RESET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED,
  RESET_ACTIONAPPROVALDOCID_ROUTE_FAILED,
} from '../../actions/approvaldocs/types';

const schema = {
  status: 'INIT', // INIT/OK/ERROR
  error: null,
  gettingapprovaldocs: false,
  resettingapprovaldocs: false,
  gotapprovaldocs: false,
  docs: {},
  downloadingUnsignedApprovalDoc: false,
  gettingUnsignedApprovalDoc: false,
  resettingUnsignedApprovalDoc: false,
  gotUnsignedApprovalDoc: false,
  downloadedUnsignedApprovalDoc: false,
  unsignedApprovalDoc: {},
  downloadUnsignedApprovalDoc: {},
  signingApprovalDocs: {
    loading: false,
    success: false,
  },
  actionapprovaldocidroute: null,
};

const initialState = Immutable.Map(schema);

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_APPROVAL_DOC:
      return state
        .set('unsignedApprovalDoc', {})
        .set('downloadUnsignedApprovalDoc', {});
    case GET_APPROVAL_DOCS_REQUESTED:
      return state.set('gettingapprovaldocs', true).set('error', null);

    case GET_APPROVAL_DOCS_COMPLETED: {
      const { contacts, docs, partnerDocs } = action.payload;

      const items = docs.map((doc) => {
        const partners = partnerDocs
          .filter((partnerDoc) => partnerDoc?.ID !== doc.ID)
          .filter(
            (partnerDoc) =>
              partnerDoc?.AccountGUID === doc.AccountGUID &&
              partnerDoc?.DocFileName === doc.DocFileName,
          )
          .map(({ ContactGUID, ActionStatus, completedAt }) => {
            const item = contacts.find(
              (contact) => contact?.ContactID === ContactGUID,
            );
            if (item) {
              const { ContactID, FirstName, LastName } = item;

              return {
                ContactID,
                FirstName,
                LastName,
                completedAt,
                ActionStatus,
              };
            }
            return {};
          });

        return {
          ...doc,
          partners,
        };
      });

      return state
        .set('gettingapprovaldocs', false)
        .set('gotapprovaldocs', true)
        .set('error', null)
        .set('docs', {
          items,
        });
    }
    case GET_APPROVAL_DOCS_FAILED:
      return state
        .set('gettingapprovaldocs', false)
        .set('gotapprovaldocs', false)
        .set('error', action.payload);

    case GET_APPROVAL_DOCS_ABORTED:
      return state
        .set('gettingapprovaldocs', false)
        .set('gotapprovaldocs', false);

    case GET_ASSIGNED_APPROVAL_DOCS_REQUESTED:
      return state.set('gettingUnsignedApprovalDoc', true).set('error', null);

    case GET_ASSIGNED_APPROVAL_DOCS_COMPLETED:
      return state
        .set('gettingUnsignedApprovalDoc', false)
        .set('gotUnsignedApprovalDoc', true)
        .set('error', null)
        .set('unsignedApprovalDoc', action.payload);

    case GET_ASSIGNED_APPROVAL_DOCS_FAILED:
      return state
        .set('gettingUnsignedApprovalDoc', false)
        .set('gotUnsignedApprovalDoc', false)
        .set('error', action.payload);

    case DOWNLOAD_ASSIGNED_APPROVAL_DOCS_REQUESTED:
      return state
        .set('downloadingUnsignedApprovalDoc', true)
        .set('error', null);

    case DOWNLOAD_ASSIGNED_APPROVAL_DOCS_COMPLETED:
      return state
        .set('downloadingUnsignedApprovalDoc', false)
        .set('downloadedUnsignedApprovalDoc', true)
        .set('error', null)
        .set('downloadUnsignedApprovalDoc', action.payload);

    case DOWNLOAD_ASSIGNED_APPROVAL_DOCS_FAILED:
      return state
        .set('downloadingUnsignedApprovalDoc', false)
        .set('downloadedUnsignedApprovalDoc', false)
        .set('error', action.payload);

    case SET_SIGNED_APPROVAL_DOC_REQUESTED:
      return state.set('signingApprovalDocs', {
        failure: false,
        loading: true,
        success: false,
      });

    case SET_SIGNED_APPROVAL_DOC_COMPLETED:
      return state.set('signingApprovalDocs', {
        failure: false,
        loading: false,
        success: true,
      });

    case SET_SIGNED_APPROVAL_DOC_FAILED:
      return state
        .set('signingApprovalDocs', {
          failure: true,
          loading: false,
          success: false,
        })
        .set('error', action.payload);

    case SET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED:
      return state
        .set('gettingdata', true)
        .set('actionapprovaldocidroute', null);

    case SET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('actionapprovaldocidroute', action.payload);

    case SET_ACTIONAPPROVALDOCID_ROUTE_ABORTED:
      return state
        .set('gettingdata', false)
        .set('actionapprovaldocidroute', null)
        .set('gotdata', false);

    case SET_ACTIONAPPROVALDOCID_ROUTE_FAILED:
      return state
        .set('gettingdata', false)
        .set('actionapprovaldocidroute', null)
        .set('gotdata', false)
        .set('error', action.payload);

    case RESET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED:
      return state
        .set('gettingdata', true)
        .set('actionapprovaldocidroute', null);

    case RESET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('actionapprovaldocidroute', null);

    case RESET_ACTIONAPPROVALDOCID_ROUTE_ABORTED:
      return state
        .set('gettingdata', false)
        .set('actionapprovaldocidroute', null)
        .set('gotdata', false);

    case RESET_ACTIONAPPROVALDOCID_ROUTE_FAILED:
      return state
        .set('gettingdata', false)
        .set('actionapprovaldocidroute', null)
        .set('gotdata', false)
        .set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
